import { QueryKey } from "@tanstack/react-query";
import { FormProvider } from "react-hook-form";
import { useNoteForm } from "../hooks/useNoteForm";
import { INoteViewModel } from "../models/noteModel";
import styles from "./NoteAddUpdateDialog.module.scss";
import { DefaultInputField } from "../../../forms/inputs/InputField/DefaultInputField";
import { HiddenField } from "../../../forms/inputs/hiddenField/HiddenField";
import { NoteFormData } from "../models/noteFormData";
import { nameof } from "ts-simple-nameof";
import { DefaultButton } from "../../../button/defaultButton/DefaultButton";
import { useFormValidationMessages } from "../../../../infrastructure/hooks/useFormHelper";

interface INoteAddUpdateDialogProps {
  createEndpoint: string;
  updateEndpoint: string;
  invalidateKeys: QueryKey[];
  note?: INoteViewModel | null;
  entityId?: number;
  onSuccess: () => void;
}

export const NoteAddUpdateDialog = ({
  createEndpoint,
  updateEndpoint,
  invalidateKeys,
  note,
  entityId,
  onSuccess,
}: INoteAddUpdateDialogProps) => {
  const { form, handleSubmit, isEditing, isLoading } = useNoteForm({
    note,
    entityId,
    createEndpoint,
    updateEndpoint,
    invalidateKeys,
    onSuccess,
  });

  useFormValidationMessages<NoteFormData>(form);

  const buttonTitle = !isEditing ? "Добави" : "Редактирай";
  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit} className={styles.root}>
        <HiddenField name={nameof<NoteFormData>((x) => x.entityId)} />

        <DefaultInputField
          name={nameof<NoteFormData>((x) => x.content)}
          placeholder="Пример: Клиентката се обади и потвърди резервацията."
          label="Бележка"
          required
          autofocus
        />

        <DefaultButton label={buttonTitle} type="submit" loading={isLoading} />
      </form>
    </FormProvider>
  );
};
